// Check if the date is valid.
// The function takes day, month and year as input and returns true if the date is valid and returns false if date is invalid

const isLeapYear = (year: string): boolean =>
  (+year % 4 === 0 && +year % 100 !== 0) || +year % 400 === 0;

export const validateDate = (
  day: string,
  month: string,
  year: string,
): boolean => {
  const newDay = day?.trim();
  const newMonth = month?.trim();
  const newYear = year?.trim();

  if (!newDay && !newMonth && !newYear) return null;

  // Check if user enters 0 for day, month or year
  if (+newDay === 0 || +newMonth === 0 || +newYear === 0) return false;

  if (!newDay || !newMonth || !newYear) return false;

  // Check if day is greater than 28 for February month when year is not a leap year
  if (+newMonth === 2 && +newDay > 28 && !isLeapYear(newYear)) return false;

  // Check if day is greater than 29 for February month when year is a leap year
  if (+newMonth === 2 && +newDay > 29 && isLeapYear(newYear)) return false;

  return true;
};
